// @flow

import * as React from "react";
import API from "../../api/";
import TileSlider from "./TileSlider";
import TextButton from "../atoms/TextButton";

type PropsType = {
    componentData: any,
};

const WhatsOn = ({ componentData }: PropsType): React.Node => {
    const [tileData, setTileData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const sports_category_ids = componentData.category || [];

    React.useEffect((): any => {
        let cancel = false;
        setIsLoading(true);

        // Fetch events from WordPress REST API
        const fetchEventsData = async () => {
            try {
                const categoryParam = Array.isArray(sports_category_ids)
                    ? sports_category_ids.join(",")
                    : sports_category_ids;
                // Use API.fetchPosts with event_category filter
                const response = await API.fetchPosts({
                    postType: "events",
                    perPage: 9,
                    filterKey: "event_category",
                    filterValue: categoryParam,
                    queryParms: {
                        orderby: "upcoming",
                    },
                });
                if (!cancel && response && response.data) {
                    setTileData(response.data);
                }
                else{
                    setTileData([]);
                }
            } catch (error) {
                console.error("Error fetching events:", error);
                setTileData([]);
            } finally {
                if (!cancel) {
                    setIsLoading(false);
                }
            }
        };

        fetchEventsData();

        return () => {
            cancel = true;
        };
    }, [sports_category_ids]);

    if (isLoading) {
        return (
            <div className="tile-slider--loading">
                <p>Loading events...</p>
            </div>
        );
    }

    return (
        <>
            {tileData.length === 0 ?(

                <div className="whats-on">
                    <div className="whats-on__no-events">
                        <div className="tile-slider__header">
                            <div className="tile-slider__header__title-container">
                                <h2 className="tile-slider__header__title">What's on</h2>
                            </div>
                            {componentData.cta ? (
                                <div className="tile-slider__header__cta-container">
                                    <TextButton
                                        customButton
                                        to={componentData.cta.url}
                                        target=""
                                    >
                                        {componentData.cta.title}
                                    </TextButton>
                                </div>
                            ) : null}
                        </div>
                        <div className="tile-slider__inner no-event">No upcoming events at the moment. Check back soon.</div>
                    </div>
                </div>
            ):(
                <div className="whats-on">
                    <TileSlider
                        useContainer={true}
                        colClass="col-xs-12"
                        title="What's on"
                        tiles={tileData}
                        cta={{
                            url: componentData.cta?.url || "",
                            title: componentData.cta?.title || "View All",
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default WhatsOn;

